import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import type { LocationAlertBody } from '../alertHover.types'
import { locationStyles } from './Location.styles'

const LocationBody: React.FC<{ body: LocationAlertBody }> = ({ body }) => {
  if (!body || !body?.homeSiteName) {
    return null
  }

  return (
    <Box sx={locationStyles.root}>
      <Typography sx={locationStyles.address}>{body?.homeSiteName}</Typography>
    </Box>
  )
}

export default LocationBody
